import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemno','itemname', 'partnumber', 'idStore', 'nmcategory', 'headcategory', 'purcOrderNo', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal', 'vendorinfo', 'gcifNo', 'outstand', 'barangbekas', 'barangbarter'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                if(obj.arrItem && obj.arrItem.length>0){
                    // const arrItemArry = obj.arrItem
                    // for (let index = 0; index < arrItemArry.length; index++) {
                    //     const element = arrItemArry[index];
                    //     str += str ? '&' : '?';
                    //     str += 'arrItem[]' + '=' + element;
                    // }   
                    str += str ? '&' : '?';
                    str += 'arrItem=' + encodeURIComponent(JSON.stringify(obj.arrItem));
                }
                
                const url = `/inventoryin${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    // note : dicek lagi perlu dipake ndak?
    listByItemsNo(obj) {
        console.log('obj',obj)
        return new Promise(async (resolve, reject) => {
            try {
                // let str =''
                // for (let index = 0; index < obj.length; index++) {
                //     const element = obj[index];
                //     str += str ? '&' : '?';
                //     str += 'itemno[]' + '=' + element;
                // }
                let str = '?arrItem=' + encodeURIComponent(JSON.stringify(obj));

                const url = `/inventoryin/ByItemsNo${str}`;
                console.log('url',url)
                const { data } = await axios.get(url);
                console.log('data ===>',data)
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    lookup() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get('/inventory');
                const {
                    list
                } = data;
                list.forEach(item => {
                    item.selected = false;
                });
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post('/inventoryin', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/inventoryin/${obj.itemReciKey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventory/detail/${obj.requestkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        console.log('obj',obj)
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemno','itemname','partnumber', 'idStore', 'nmcategory', 'headcategory', 'purcOrderNo', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal', 'vendorinfo', 'gcifNo', 'outstand', 'barangbekas', 'barangbarter'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/inventoryin/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Inventory_Receipt_PO.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    store() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventory/store`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    inventorygroup(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/inventorycategory/combo`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    //
    detailInvReceipt(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventoryin/detailInvReceipt/${obj.itemReciKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }, 
    invReceipt_save(obj={}){
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post('/inventoryin/invReceiptSave', obj);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    poReceivePrint(obj={}){
        return new Promise(async (resolve, reject) => {
            try {
                console.log(' poReceivePrint obj',obj);
                console.log('poReceivePrint',obj.purcOrderNo)
                if(obj.purcOrderNo){
                    const url = `/inventoryin/poReceivePrint?key=${obj.purcOrderNo}`;
                    const { data } = await axios.get(url);
                    const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                    resolve(link);
                }
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }
};